<template>

<Navigacija @reload-parent="methodThatForcesUpdate" yvisina=15 iocon="1">
  <template #atag><a></a></template>
      <template #content>
        

<div id="baseApp" style="padding-top: 100px;">




    <div class="wrapper fadeInDown">
        <div id="formContent">
              <br>
          <span v-if="this.$store.state.token">
           <!--<button @click="changeAktivnost" style="color:White;" class="btn btn-info"><template v-if="aktivan">Aktivan</template><template v-else>Neaktivan</template></button>&nbsp;-->
           <p>You are logged in</p><br>
           <button @click="logout()" class="btn btn-danger">Sign out</button><br><br>

           </span>
          <!-- Tabs Titles -->
          <span v-if="!this.$store.state.token">
          <h2 class="active"> Prijava </h2>

      
          <!-- Icon -->
          <div class="fadeIn first">
            <i id='icon' style="font-size:30px; color:gray; padding-bottom:10px; padding-top:10px;" class="fa fa-user" aria-hidden="true"></i>
          </div>
      <span v-if="!beforeCreate">
          <!-- Login Form -->
          <form @submit.prevent="getTokenSubmit">
          <input type="text" name="ime" placeholder="Ime" class="fadeIn third logininput" maxlength="50" id="id_ime" autocomplete="off" v-model="username">
          <input type="password" name="password" placeholder="Lozinka" class="fadeIn third logininput"  required="" id="id_password" oninvalid="this.setCustomValidity('Unesite Lozinku')" autocomplete="off"  v-model="password">


            <input type="submit" class="fadeIn fourth" value="Prijavi Se">
           
          </form>
          </span>
        </span>
      
          <!-- Remind Passowrd -->
          <div id="formFooter">
            <a class="underlineHover" id="admin" href="https://mpguest-c283362298bc.herokuapp.com/admin/">Admin interface</a>
          </div>
      
        </div>
      </div>
</div>

      </template>

</Navigacija>


</template>


<script>
import { PushNotifications } from '@capacitor/push-notifications';
import Navigacija from '../components/Navigacija.vue'
import axios from 'axios'
import store from '../store'
export default {
  components: {
    Navigacija
  },

    name: 'LogIn',
    data() {
        return {
     
            username: '',
            prijeusername:'',
            aktivnost: '',
            password: '',
            errors: [],
            formToken:{
              fcmtoken:'',
              vrsta:'staff',
            },
            device:"",
            usrtoken:{
              token:'',
              vrsta:'staff',
              device:"",
            },
            restorani:['paleopark', 'portobus', 'sanpolo'],
            aktivan:false,
            
  
        }
    },
  
    mounted() {
      this.device = Capacitor.getPlatform();
      if(this.device == "web"){
        this.usrtoken.device = "web"
      }
      else{
        this.usrtoken.device = "mobile"
      }
      this.prijeusername = localStorage.getItem('username')

      if(this.device!="web"){
      
        this.registerNotifications()
        

     
        }
      
          
        
      

    },
    methods: {
      async registerNotifications() {

      let permStatus = await PushNotifications.checkPermissions();

      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
      }

  
      await PushNotifications.register();

      // Move the addListener logic here
      PushNotifications.addListener('registration', (token) => {
        this.formToken.fcmtoken = token.value;
      });
    },
      

       async logout() {

        this.usrtoken.token = localStorage.getItem('token')


        if (this.usrtoken.token){

        

    
       await axios
                .post("/api/odjava/", this.usrtoken)
                .then(response => {
                    
                this.$root.toastnoti("Uspjeh!", "Odjavljeni ste", "greska")
                })
                .catch(error => {
                  this.$root.toastnoti("Uspjeh!", "Odjavljeni ste", "greska")
                })
                
          
        localStorage.removeItem("token")
        localStorage.removeItem("username")
        localStorage.removeItem("userid")
        localStorage.removeItem("grupe")
        this.$store.commit('removeToken')
       
        axios.defaults.headers.common["Authorization"] = ""
          }
            
        },
        getTokenSubmit(){
          this.submitForm()
        


        },
        async submitForm() {
          this.usrtoken.token = localStorage.getItem('token')
          if (this.usrtoken.token){
            console.log(this.usrtoken)
        

        await axios
              .post("/api/odjava/", this.usrtoken)
              .catch(error => {
                localStorage.removeItem("token")
                localStorage.removeItem("username")
                localStorage.removeItem("userid")
                localStorage.removeItem("grupe")
                this.$store.commit('removeToken')
                axios.defaults.headers.common["Authorization"] = ""
                      
                })
               
      }
            const formData = {
                username: this.username,
                password: this.password,
                fcmtoken:this.formToken.fcmtoken,
                vrsta:'staff',
            }
            console.log(this.aktivan)
            
            await axios
                .post("/api/api-token-auth/", formData)
                .then(response => {
       
                    const token = response.data.token
                    this.aktivan = response.data.aktivnost

                    localStorage.setItem('aktivan', this.aktivan)
                    this.$store.commit('setToken', token)
                    
                    axios.defaults.headers.common["Authorization"] = "Token " + token
                    localStorage.setItem("token", token)
                    localStorage.setItem("username", this.username)
                    localStorage.setItem("grupe", response.data.grupe)
                    if(this.username=="paleopark" || this.username=="molpicio"){
       
       this.$router.push(this.$route.query.to || '/kontrolna/restoran/')
     }
     else{
       this.$router.push(this.$route.query.to || '/')
     }

     

               
                 
                
                    this.$root.toastnoti("Uspjeh!", "Prijavljeni ste", "uspjeh")
                })
                .catch(error => {
                  this.$root.toastnoti("Greška!", error.response.data, "greska")
                
                })
        }
    }
}
</script>


<style scoped>


#baseApp:after {
    content: '';
    background-image: url(../assets/img/services-right-dec.jpg);
    background-repeat: no-repeat;
    position: absolute;
    right: 0;
    top: 400px;
    width: 161px;
    height: 413px;
    z-index: -1;
  }
  

.menu li #podsjetnik{
  opacity: 0.5;
  }



html {
    background-color: #f7fcff;
  }

body {
  font-family: "Poppins", sans-serif;
  height: 80vh;
}

#admin {
  color: #92badd;
  display:inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display:inline-block;
  margin: 40px 8px 10px 8px; 
  color: #cccccc;
}




/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column; 
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}



/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}



/* FORM TYPOGRAPHY*/

input[type=button], input[type=submit], input[type=reset]  {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover, input[type=submit]:hover, input[type=reset]:hover  {
  background-color: #39ace7;
}

input[type=button]:active, input[type=submit]:active, input[type=reset]:active  {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

.logininput{
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder {
  color: #cccccc;
}



/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

.fadeIn {
  opacity:0;
  -webkit-animation:fadeIn ease-in 1;
  -moz-animation:fadeIn ease-in 1;
  animation:fadeIn ease-in 1;

  -webkit-animation-fill-mode:forwards;
  -moz-animation-fill-mode:forwards;
  animation-fill-mode:forwards;

  -webkit-animation-duration:1s;
  -moz-animation-duration:1s;
  animation-duration:1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after{
  width: 100%;
}



/* OTHERS */

*:focus {
    outline: none;
} 

#icon {
  width:60%;
}

* {
  box-sizing: border-box;
}

</style>

<script></script>
